import React from "react";
import "../css/Main.css";
// import { carouselData } from "../rawData/kidsAPI";

const MainScreen = () => {
  return (
    <>
      <div id="demo" className="carousel slide" data-ride="carousel">
        <ul className="carousel-indicators">
          <li data-target="#demo" data-slide-to="0" className="active dot"></li>
          <li data-target="#demo" data-slide-to="1"></li>
          <li data-target="#demo" data-slide-to="2"></li>
        </ul>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              src="/images/module1.jpg"
              alt="Los Angeles"
              className="w-100"
            />
          </div>

          <div className="carousel-item">
            <img
              src="/images/module2.jpg"
              alt="Chicago"
              classNameName="w-100"
            />
          </div>

          <div className="carousel-item">
            <img
              src="/images/module3.jpg"
              alt="New York"
              classNameName="w-100"
            />
          </div>
        </div>

        <a className="carousel-control-prev" href="#demo" data-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </a>
        <a className="carousel-control-next" href="#demo" data-slide="next">
          <span className="carousel-control-next-icon"></span>
        </a>
      </div>
    </>
  );
};

export default MainScreen;
